export const sliderInit = () => {
  var swiper = new Swiper('.swiper-container', {
    loop: true,
    centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    slidesPerView: 5,
    spaceBetween: 40,
    // Responsive breakpoints
    breakpoints: {
      // when window width is <= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      // when window width is <= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      // when window width is <= 640px
      
      640: {
        slidesPerView: 2,
        spaceBetween: 30
      },
     
      1000: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  });
}